import React from "react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { withTranslation } from "react-i18next";
import Moment from "react-moment";
import {
	FormGroup,
	FormControl,
	FormLabel,
	Dropdown,
	Col,
	Row,
} from "react-bootstrap";
import { FiTrash2, FiMoreHorizontal, FiCalendar } from "react-icons/fi";
import { companyService } from "services";
import { errorFormating } from "utils/utils";
import SubmitButton from "components/SubmitButton";
import * as companyActions from "actions/companyActions";

import DatePicker, { registerLocale } from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es"; // datepicker locale
registerLocale("es", es);

class CompanySubscriptionsEdit extends React.Component {
	constructor(props) {
		super(props);
		// console.log(props);
		let isEdit = false;

		const current_subscription = {
			subscription_type: "",
			max_users: "",
			start_day: "",
			end_day: "",
		};

		this.state = {
			isEdit,
			isLoading: false,
			submitted: false,
			errors: {},
			current_subscription,
			company_subscriptions: [],
		};
	}

	async componentDidMount() {
		const companyId = this.props.partner_company.id;
		// console.log(companyId);
		// await this.props.getCompany(companyId);
		// console.log(this.props.company);

		await Promise.all([
			this.props.getAllSubscriptions(companyId),
			this.props.getSubscriptionTypes(),
		]);
		// console.log(this.props.company_subscriptions);

		const subs = this.props.company_subscriptions || [];
		let current_subscription = this.state.current_subscription;

		if (subs.length > 0) {
			const last = subs[0];
			current_subscription = {
				subscription_type: last.subscription_type?.name || "",
				max_users: last.max_users || "",
				start_day: last.start_day || "",
				end_day: last.end_day || "",
			};
		}

		this.setState({
			company: this.props.company,
			company_subscriptions: this.props.company_subscriptions || [],
			current_subscription,
		});
	}

	handleChange = (event) => {
		const { current_subscription } = this.state;

		this.setState({
			current_subscription: {
				...current_subscription,
				[event.target.id]: event.target.value,
			},
		});
	};

	handleDateChange = (field, date) => {
		const { current_subscription } = this.state;

		this.setState({
			current_subscription: {
				...current_subscription,
				// [field]: date ? moment(date).format("YYYY-MM-DD") : "",
				[field]: date ? moment.utc(date).format() : "",
			},
		});
	};

	handleUseToday = (field) => {
		const today = moment().startOf("day").toDate(); // hoy a las 00:00
		this.handleDateChange(field, today);
	};

	checkValidField = (name) => {
		return (
			this.state.submitted &&
			this.state.errors[name] !== undefined &&
			this.state.errors[name] !== ""
		);
	};

	normalizeSubscriptionPayload = (data) => {
		const payload = { ...data };

		// Si viene un objeto, nos quedamos solo con el name
		if (
			payload.subscription_type &&
			typeof payload.subscription_type === "object"
		) {
			payload.subscription_type = payload.subscription_type.name;
		}

		return payload;
	};

	handleSubmit = async (event) => {
		event.preventDefault();

		this.setState({ isLoading: true });
		const props = this.props;
		let response = null;
		const { current_subscription, company_subscriptions } = this.state;
		const companyId = this.props.partner_company.id;

		// siempre existe al menos una suscripción
		const last = company_subscriptions[0];

		const lastType = last.subscription_type?.name || "";
		const lastUsers = String(last.max_users ?? "");
		const newType = current_subscription.subscription_type || "";
		const newUsers = String(current_subscription.max_users ?? "");

		// si solo cambian fechas -> UPDATE
		const onlyDatesChanged = lastType === newType && lastUsers === newUsers;

		if (onlyDatesChanged) {
			// UPDATE de la suscripción actual (la última)
			let payloadUpdate = {
				...last,
				...current_subscription,
			};

			payloadUpdate = this.normalizeSubscriptionPayload(payloadUpdate);

			response = await companyService.updateSubscription(
				companyId,
				payloadUpdate
			);
		} else {
			// CREATE: ha cambiado tipo o num usuarios
			response = await companyService.createSubscription(
				companyId,
				current_subscription
			);

			// si la creación ha ido bien, cerramos la anterior
			if (response.ok) {
				let updatedLast = {
					...last,
					end_day: current_subscription.start_day, // fin = inicio de la nueva
				};

				updatedLast = this.normalizeSubscriptionPayload(updatedLast);

				try {
					await companyService.updateSubscription(companyId, updatedLast);
				} catch (e) {
					console.error("Error actualizando la suscripción anterior:", e);
				}
			}
		}

		// console.log(response);

		if (response.ok) {
			this.setState(
				{
					isLoading: false,
					errors: {},
				},
				() => {
					toastr.success(this.props.t('common.success'), this.props.t('common.changesSaved'));
					this.props.getAllSubscriptions(companyId);
					props.handleClose();
				}
			);
		} else {
			this.setState({
				isLoading: false,
				submitted: true,
				errors: errorFormating(response),
			});
		}
	};

	getSubscripcionRows = () =>
		this.state.company_subscriptions.map((subscription) => {
			// console.log(subscription);

			return (
				<tr key={subscription.id}>
					<td>{moment(subscription.start_day).format("DD/MM/YY") || "-"}</td>
					<td>{subscription.subscription_type.name}</td>
					<td>{subscription.max_users}</td>
					<td>
						{subscription.end_day
							? moment(subscription.end_day).format("DD/MM/YY")
							: "-"}
					</td>
				</tr>
			);
		});

	render() {
		const { company_subscriptions, current_subscription, errors } = this.state;
		const { subscription_types, t } = this.props;
		var isActive = current_subscription.enabled;
		const typesOptionList =
			subscription_types.length > 0 &&
			subscription_types.map((item, i) => {
				return (
					<option key={i} value={item.name}>
						{item.name}
					</option>
				);
			}, this);

		const employeesOptionList = Array.from({ length: 3001 }, (_, i) => (
			<option key={i} value={i}>
				{i}
			</option>
		));

		return (
			<form className="modal-company-subscriptions">
				<div className="modal-body">
					<p
						style={{ marginTop: "-20px" }}
						className="text-uppercase text-muted mb25"
					>
						{this.props.partner_company.name}
					</p>
					<div class="box-info">
						<h5 className="">{t("subscriptionsPage.editModal.currentSubscription")}</h5>

						<Row>
							<Col sm={6} md={4} lg={4}>
								<FormGroup className="form-group" controlId="subscription_type">
									<FormLabel>
										{t("subscriptionsPage.editModal.type")} <span className="label-required">*</span>
									</FormLabel>
									<FormControl
										type="text"
										value={current_subscription.subscription_type}
										onChange={this.handleChange}
										isInvalid={this.checkValidField("subscription_type")}
										as="select"
									>
										<option value="">{t("subscriptionsPage.editModal.selectType")}</option>
										{typesOptionList}
									</FormControl>

									<FormControl.Feedback type="invalid">
										{errors.shift_id}
									</FormControl.Feedback>
								</FormGroup>
							</Col>
							<Col sm={6} md={4} lg={2}>
								<FormGroup className="form-group" controlId="max_users">
									<FormLabel>
										{t("subscriptionsPage.editModal.employees")} <span className="label-required">*</span>
									</FormLabel>
									<FormControl
										onChange={this.handleChange}
										value={current_subscription.max_users}
										isInvalid={this.checkValidField("max_users")}
										as="select"
									>
										{employeesOptionList}
									</FormControl>
									<FormControl.Feedback type="invalid">
										{this.state.errors.max_users}
									</FormControl.Feedback>
								</FormGroup>
							</Col>
							<Col sm={6} md={4} lg={3}>
								<FormGroup
									controlId="start_day"
									className={`form-group mb0 form-date form-date-clearable ${
										current_subscription.start_day === "" && "empty"
									}  ${this.checkValidField("start_day") && "is-invalid"}`}
								>
									<FormLabel>
										{t("subscriptionsPage.editModal.startDate")} <span className="label-required">*</span>
									</FormLabel>
									<DatePicker
										selected={
											current_subscription.start_day === "" ||
											!current_subscription.start_day
												? null
												: moment(current_subscription.start_day).toDate()
										}
										onChange={(date) =>
											this.handleDateChange("start_day", date)
										}
										isInvalid={this.checkValidField("start_day")}
										className="form-control"
										dateFormat="dd/MM/yyyy"
										locale="es"
										placeholderText="dd/mm/aaaa"
										isClearable
									/>
									<button
										type="button"
										className="btn btn-link p-0 mt-1 fs12"
										onClick={() => this.handleUseToday("start_day")}
									>
										{t("subscriptionsPage.editModal.useToday")}
									</button>
									<FormControl.Feedback type="invalid">
										{this.state.errors.start_day}
									</FormControl.Feedback>
								</FormGroup>
							</Col>
							<Col sm={6} md={4} lg={3}>
								<FormGroup
									controlId="end_day"
									className={`form-group mb0 form-date form-date-clearable ${
										current_subscription.end_day === "" && "empty"
									}  ${this.checkValidField("end_day") && "is-invalid"}`}
								>
									<FormLabel>{t("subscriptionsPage.editModal.endDate")}</FormLabel>
									<DatePicker
										selected={
											current_subscription.end_day === "" ||
											!current_subscription.end_day
												? null
												: moment(current_subscription.end_day).toDate()
										}
										onChange={(date) => this.handleDateChange("end_day", date)}
										isInvalid={this.checkValidField("end_day")}
										className="form-control"
										dateFormat="dd/MM/yyyy"
										locale="es"
										placeholderText="dd/mm/aaaa"
										isClearable
									/>
									<button
										type="button"
										className="btn btn-link p-0 mt-1 fs12"
										onClick={() => this.handleUseToday("end_day")}
									>
										{t("subscriptionsPage.editModal.useToday")}
									</button>
									<FormControl.Feedback type="invalid">
										{this.state.errors.end_day}
									</FormControl.Feedback>
								</FormGroup>
							</Col>
						</Row>
					</div>

					{company_subscriptions.length > 1 && (
						<>
							<h5 className="mt25">{t("subscriptionsPage.editModal.history")}</h5>

							<table className="table table-subscriptions table-zebra">
								<thead>
									<tr>
										<th>{t("subscriptionsPage.editModal.historyStart")}</th>
										<th>{t("subscriptionsPage.editModal.historyType")}</th>
										<th>{t("subscriptionsPage.editModal.historyUsers")}</th>
										<th>{t("subscriptionsPage.editModal.historyEnd")}</th>
									</tr>
								</thead>
								<tbody>{this.getSubscripcionRows()}</tbody>
							</table>
						</>
					)}
				</div>

				<div className="modal-footer">
					<button
						type="button"
						onClick={this.props.handleClose}
						className="btn btn-outline-primary"
					>
						{t("common.close")}
					</button>
					<SubmitButton
						type="button"
						isLoading={this.state.isLoading}
						text={this.props.t('common.save')}
						loadingText={this.props.t('common.saving')}
						onClick={this.handleSubmit}
					/>
				</div>
			</form>
		);
	}
}

const mapStateToProps = (reducers) => {
	const r = {
		...reducers.companyReducer,
		user: reducers.authReducer.user,
	};
	return r;
};

const mapDispatchToProps = (dispatch) => ({
	// hideModal: () => dispatch(hideModal()),
	// showModal: (modalProps, modalType) => {
	// 	dispatch(showModal({ modalProps, modalType }));
	// },
	getCompany: (company_id) => dispatch(companyActions.getCompany(company_id)),
	getAllSubscriptions: (companyId) =>
		dispatch(companyActions.getAllSubscriptions(companyId)),
	getSubscriptionTypes: () => dispatch(companyActions.getSubscriptionTypes()),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withTranslation()(CompanySubscriptionsEdit));
